/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menudropactive2Inputs */

const en_menudropactive2 = /** @type {(inputs: Menudropactive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop to add`)
};

const de_menudropactive2 = /** @type {(inputs: Menudropactive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loslassen zum Hinzufügen`)
};

/**
* | output |
* | --- |
* | "Drop to add" |
*
* @param {Menudropactive2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menudropactive2 = /** @type {((inputs?: Menudropactive2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menudropactive2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menudropactive2(inputs)
	return de_menudropactive2(inputs)
});
export { menudropactive2 as "menuDropActive" }